import type { CmsItem } from '~/types/cms';

export const useConvertedLink = (item: CmsItem) => {
    let link = item.url;
    if (item.element) {
        const localePath = useLocalePath();
        const itemElement = item.element;
        const slug = (itemElement.slug || '').split('/').filter(Boolean);

        const converted: Record<string, any> = {
            home: {
                name: 'index'
            },
            pages: {
                name: 'slug',
                params: {
                    slug
                }
            },
            news: {
                name: 'news-slug',
                params: {
                    slug: itemElement.slug
                }
            },
            locations: useLocationRouteTarget(itemElement)
        };

        const targetRoute = converted[itemElement.sectionHandle];
        if (targetRoute) {
            link = localePath(targetRoute);
        }
    }

    return link;
};
